import { render } from "./Mo.vue?vue&type=template&id=5390ba97&scoped=true"
import script from "./Mo.vue?vue&type=script&lang=js"
export * from "./Mo.vue?vue&type=script&lang=js"

import "./Mo.vue?vue&type=style&index=0&id=5390ba97&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5390ba97"

export default script